<template>
    <div class="search-condition-date-time" :value="value">
        <label v-if="typeof labelText !== 'undefined'">{{labelText}}
            <span v-if="required" style="color:#FC1111;">*</span></label>
        <input type="text"
               id="date-time"
               name="date-time"
               :value="value"
               v-on:change="dateTimeChange"
               :placeholder="placeholder"
               data-date-format="yyyy/mm/dd HH:mm"
               onfocus="(this.type='datetime-local')">
    </div>
</template>

<script>
    export default {
        name: "BInputDateTime",
        props: {
            labelText: String,
            value: String,
            required: Boolean,
            placeholder: String,
        },
        methods: {
            dateTimeChange(event) {
                //var date = String(event.target.value).replace('T', ' ')+ ':00'
                this.$emit("dateTimeChange", String(event.target.value));
            }
        }
    }
</script>

<style scoped>
    .search-condition-date-time {
        display: flex;
        align-items: center;
    }

    .search-condition-date-time label {
        display: flex;
        color: #333333;
        width: 65px;
        text-align: right;
        margin: 0 10px 0 20px;
    }

    .search-condition-date-time input {
        width: 220px;
        height: 42px;
        background: #FFFFFF;
        border: 1px solid #DEE2E6;
        border-radius: 5px;
        color: #666666;
        padding-left: 10px;
        padding-right: 10px;
    }

    input:focus {
        border: 1px solid #0171A3;
    }

    * {
        outline: none;
    }
</style>